import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly10E2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/6.webp`;
  const p7 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/7.webp`;
  const p8 = `${config.base_image_url_2026}/home/events-activities/class-assembly/10E/8.webp`;




  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },
    { src: p7, source: p7, rows: 1, cols: 1 },
    { src: p8, source: p8, rows: 1, cols: 1 }
  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
          EMBRACE AYURVEDA, EMBRACE BALANCE OF BODY AND MIND
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 10E   DATE: 18 JUNE 2026
                </Typography>

<Typography variant={'subtitle1'} align={'justify'}>
  The students of Class 10E presented a thoughtful and engaging assembly on the theme 
  "Embrace Ayurveda Embrace Balance of Body and Mind." The presentation highlighted the 
  timeless wisdom of Ayurveda and its relevance in maintaining a healthy and balanced 
  lifestyle in today's fast-paced world. Through an informative and creative skit, the students explained the fundamental 
  principles of Ayurveda and emphasized the importance of achieving harmony between the body, mind, and spirit.
  <br></br>
  The skit beautifully portrayed the concept of the three doshas<strong>—Vata, Pitta, and Kapha—</strong>which form the foundation of Ayurvedic philosophy.
   Through relatable characters and everyday situations, the students demonstrated how an imbalance in these doshas can affect physical and mental
    well-being. They further showcased simple Ayurvedic practices such as maintaining a balanced diet, 
    following a healthy daily routine, practicing yoga and meditation, 
  and using natural remedies to restore equilibrium and promote overall wellness. 
Adding a vibrant artistic dimension to the assembly, the students also performed a graceful 
dance that depicted the unique characteristics of the three doshas through expressive movements and coordinated choreography. 
The performance effectively conveyed the dynamic energy of Vata, the fiery determination of Pitta, and the calm stability of Kapha,
 illustrating how balance among these forces contributes to overall health and well-being.
  The dance captivated the audience and reinforced the assembly's central message in a creative and memorable manner.
  <br></br>
  The assembly was also highly interactive and engaging. A quiz tested student’s 
  knowledge of Ayurvedic principles, medicinal herbs, and healthy lifestyle habits,
   generating enthusiastic participation from the audience. 
It was an inspiring and well-executed presentation that left the audience with a deeper
 understanding of Ayurveda and motivated them to adopt healthy habits for achieving balance of body and mind.
  <br></br>
 
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
                "EMBRACE AYURVEDA, EMBRACE BALANCE OF BODY AND MIND"  
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10E 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly10E2026;
